import { Link } from 'react-router-dom';
import { catalog } from '@/mocks/catalog';
import { formatViews } from '@/utils/format';

const CHANNELS = [
  { to: '/category/movie', icon: 'ri-film-line', label: '电影频道', desc: '院线新片 / 经典佳作' },
  { to: '/category/tv', icon: 'ri-tv-2-line', label: '电视剧频道', desc: '热播剧集 / 口碑长剧' },
  { to: '/news', icon: 'ri-newspaper-line', label: '影视资讯', desc: '观影指南 / 行业观察' },
  { to: '/about', icon: 'ri-information-line', label: '关于我们', desc: '品牌介绍 / 联系方式' },
];

const TOPICS = ['科幻', '古装', '悬疑', '家庭', '青春', '犯罪', '都市', '奇幻'];

export default function HomeSidebar() {
  const top5 = [...catalog].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <aside className="space-y-6 lg:sticky lg:top-24 h-fit">
      <div className="rounded-lg border border-background-200 bg-background-100 p-4">
        <h3 className="font-heading font-bold text-base text-foreground-950 mb-3 flex items-center gap-2">
          <i className="ri-compass-3-line text-primary-500"></i>
          栏目导航
        </h3>
        <ul className="space-y-1">
          {CHANNELS.map((channel) => (
            <li key={channel.to}>
              <Link
                to={channel.to}
                className="flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-background-50 transition-colors group"
              >
                <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                  <i className={`${channel.icon} text-base`}></i>
                </span>
                <span className="min-w-0">
                  <span className="block text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {channel.label}
                  </span>
                  <span className="block text-xs text-foreground-500 truncate">{channel.desc}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-4">
        <h3 className="font-heading font-bold text-base text-foreground-950 mb-3 flex items-center gap-2">
          <i className="ri-bar-chart-2-line text-accent-500"></i>
          本周热度榜
        </h3>
        <ol className="space-y-2.5">
          {top5.map((item, i) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="flex items-center gap-3 group">
                <span
                  className={`w-5 text-center font-heading font-extrabold text-sm shrink-0 ${
                    i < 3 ? 'text-accent-500' : 'text-foreground-300'
                  }`}
                >
                  {i + 1}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  <span className="block text-xs text-foreground-400">
                    {formatViews(item.views)} 热度
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-4">
        <h3 className="font-heading font-bold text-base text-foreground-950 mb-3 flex items-center gap-2">
          <i className="ri-price-tag-3-line text-secondary-500"></i>
          推荐专题
        </h3>
        <div className="flex flex-wrap gap-2">
          {TOPICS.map((topic) => (
            <Link
              key={topic}
              to={`/category/movie?genre=${encodeURIComponent(topic)}`}
              className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              # {topic}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}